import { Grid } from '@mui/material'
import styled from 'styled-components'
import { ITheme } from 'theme/interface'
import logo from '../../../assets/images/logo.svg'

interface IMenuList {
  className?: string
  theme: ITheme
}

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: stretch;
  min-width: 0;
  min-height: 0;

  @media (max-width: 480px) {
    flex-direction: column-reverse;
  }
`

export const LeftContainer = styled.div<{
  windowHeight: number
  windowWidth: number
  isCenter?: boolean
}>`
  ${({ isCenter }) =>
    isCenter
      ? `
    flex: 1;
    min-width: 0;
    width: auto;
    margin: 0;
  `
      : `
    width: 1200px;
    margin: 0 auto;
  `}
  height: ${({ windowHeight }) => windowHeight}px;
  display: flex;
  overflow-y: scroll;

  @media (max-width: 480px) {
    width: 100%;
    height: 100%;
    overflow-y: hidden;
  }
`

export const RightContainer = styled.div`
  flex-shrink: 0;
  max-width: 400px;
  width: min(400px, 100%);
  display: flex;
  padding-top: 60px;

  @media (max-width: 480px) {
    width: 100%;
    max-width: none;
  }
`

export const GridContent = styled(Grid)<{
  noMaxWidth?: boolean
  windowHeight?: number
  resize?: boolean
}>`
  width: 100%;
  min-width: 0;
  height: 100%;
  position: relative;
  padding-top: 30px;
  overflow-y: scroll;
`

export const TopContent = styled.div`
  width: 100%;
  padding: 20px;

  .text-content {
    margin-bottom: 16px;

    p,
    span {
      font-size: 14px !important;
      font-weight: 500 !important;
      color: ${({ theme }) => theme.colors.dark} !important;
    }

    p {
      font-weight: normal !important;
    }
  }

  .button-content {
    width: 100%;
    margin-top: 20px;
  }
`

export const Menu = styled.nav`
  margin-top: 20px;

  ul {
    width: 100%;

    li {
      width: 100% !important;
      list-style: none;

      button {
        width: 100%;
        background-color: transparent;
        height: 40px;
        border: none;
        text-align: left;
        font-size: 16px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.secondary};
        padding-left: 20px;
        outline: none !important;

        :disabled {
          opacity: 0.5;
          cursor: no-drop;
        }
      }
    }
  }
`

export const MenuList = styled.li<IMenuList>`
  width: 100%;
  background-color: ${({ className, theme }) =>
    className === 'active' ? theme.colors.background : 'transparent'};
  border-left: ${({ className, theme }) =>
    className === 'active'
      ? `2px solid ${theme.colors.secondary}`
      : 'none'} !important;

  border-top: 1px solid
    ${({ className, theme }) =>
      className === 'active' ? 'transparent' : theme.colors.gray10} !important;
  height: 40px;
  border: none;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.secondary};
`

export const MenuUnreadBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 8px;
  padding: 0 5px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  background: #d32f2f;
  vertical-align: middle;
`

export const PatientContent = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;

  h3 {
    font-size: 18px !important;
    font-weight: 500 !important;
    color: ${({ theme }) => theme.colors.dark};
  }

  p {
    font-size: 14px !important;
    line-height: 20px !important;
    font-weight: normal !important;
    color: ${({ theme }) => theme.colors.gray80} !important;
    margin-top: 15px;

    span {
      font-weight: 600 !important;
    }
  }

  .PatientContent--header {
    @media screen and (min-width: 546px) {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: row;
    }
  }

  .PatientContent--contact {
    display: flex;
    flex-direction: column;

    h4 {
      margin-bottom: 0.5rem !important;
      padding-bottom: 0.5rem !important;
    }

    p {
      padding: 0 !important;
      margin: 0 !important;
    }
  }
`

export const SectionContent = styled.section`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray10};
  border-radius: ${({ theme }) => theme.radius.default}px;
  padding: 30px;

  span {
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 20px !important;
  }

  p {
    font-size: 14px !important;
    line-height: 18px !important;
    color: ${({ theme }) => theme.colors.gray50} !important;
  }

  .subsection {
    .subsection-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;

      span {
        font-size: 14px !important;
        color: ${({ theme }) => theme.colors.gray80} !important;
      }

      p {
        font-size: 16px !important;
        color: ${({ theme }) => theme.colors.dark} !important;
        font-weight: 600 !important;
        line-height: 22px !important;
      }

      .vital-content {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

        .vital-content-left {
          width: 80%;
        }

        .vital-content-right {
          display: flex;
          flex: 1;
          justify-content: flex-start;
          padding-left: 10px;
        }
      }
    }

    .cards-prescriptions {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`

export const SectionNutri = styled.section`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray10};
  border-radius: ${({ theme }) => theme.radius.default}px;
  padding: 30px;

  > span {
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 20px !important;
  }

  > p {
    font-size: 14px !important;
    line-height: 18px !important;
    color: ${({ theme }) => theme.colors.gray50} !important;
  }

  .text {
    strong {
      font-size: 26px !important;
      font-weight: 600 !important;
    }
  }

  .headerFoodMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .divider {
      width: 60%;
      height: 1px;
      background-color: ${({ theme }) => theme.colors.gray10};
    }

    button {
      width: 100px;
      height: 36px;
      background-color: transparent;
      border-radius: 10px;
      border: 1px solid ${({ theme }) => theme.colors.primaryDark};
      color: ${({ theme }) => theme.colors.primaryDark};
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
    }
  }

  .objective {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray60};
  }

  .foodMenu {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;

    .foodMenuItem {
      width: 50%;
    }

    .foodMenuTitle {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray70};
    }

    .foodMenuText {
      font-size: 16px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray90};
    }
  }

  .breakfast {
    display: flex;
    flex-direction: column;
    background-color: #f2f4f7;
    border-radius: 12px;
    margin-bottom: 16px;
  }

  .breakfastTitle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #fff3e3;
    padding: 16px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .breakfastTitleContent {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .breakfastTitleText {
      font-size: 16px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray90};
      margin: 0;
    }

    .breakfastTitleSubText {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray60};
      margin: 0;
      margin-top: 4px;
    }

    .regenerateButton {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #faf8f5;
      border: 1px solid #d0d5dd;
      border-radius: 6px;
      padding: 6px 12px;
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray90};
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      white-space: nowrap;
      margin-left: 16px;

      &:hover:not(:disabled) {
        background-color: #f5f3f0;
        border-color: #a8b3c0;
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      span {
        display: flex;
        align-items: center;
      }

      svg {
        display: flex;
        align-items: center;
      }
    }
  }

  .breakfastContent {
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 16px;
  }

  .breakfastContentItem {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #d0d5dd;
  }

  .breakfastContentItemContent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .breakfastContentItemText {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray90};
  }

  .breakfastContentItemSubText {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray70};

    border: 1px solid #d0d5dd;
    border-radius: 16px;
    padding: 4px 8px;
    margin-bottom: 8px;
  }

  .breakfastContentItemTextSecondary {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray60};
  }
`

export const PlanIncluded = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f2f4f7;

  border-radius: 12px;
  margin-top: 20px;

  .planIncludedHeader {
    display: flex;
    flex-direction: column;
    background-color: #fff3e3;
    padding: 16px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    h4 {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray90};
      margin: 0;
    }
  }

  .planIncludedBody {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 24px;
    padding: 16px;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    h4 {
      font-size: 14px;
    }
  }

  .planIncludedList {
    padding-left: 18px;
    margin-bottom: 0;
    color: ${({ theme }) => theme.colors.gray70};
  }
`

export const PlanIncludedEdit = styled(PlanIncluded)`
  background-color: transparent;
  border: none;
  margin-top: 0;

  .planIncludedHeader {
    display: none;
  }

  .planIncludedBody {
    grid-template-columns: 1fr;
    gap: 16px;
    background-color: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
  }

  .foodMenuTextarea {
    width: 100%;
    min-height: 140px;
    border-radius: 8px;
    border: 1px solid #d0d5dd;
    padding: 10px 14px;
    resize: vertical;
  }
`

/* Editor - bloco de refeição sem título */
export const MealEditBox = styled.div`
  position: relative;
  border-radius: 12px;
  background-color: #f2f4f7;
  padding: 16px;
  margin-bottom: 16px;

  .closeButton {
    position: absolute;
    top: -12px;
    right: -12px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #ffcfd6;
    border: 1px solid #ff4242;
    color: #ff4242;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
`

/* Componente para adicionar nova refeição */
export const AddMealContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f2f4f7;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;

  .addMealLabel {
    font-size: 14px;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: 8px;
  }

  .addMealInputContainer {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .addMealInput {
    flex: 1;
    height: 44px;
    border-radius: 8px;
    border: 1px solid #d0d5dd;
    padding: 10px 14px;
    font-size: 14px;
  }

  .addMealButton {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: #fff3e3;
    border: none;
    color: #ffa947;
    font-size: 24px !important;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
      background-color: #fff3e3;
      transform: scale(1.05);
    }
  }
`

export const AttachmentsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 40px;

  .files {
    width: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    border: none;
    outline: none;
    background-color: transparent;
    padding-top: 30px;

    img {
      width: 56px;
      height: 75.6px;
      margin-bottom: 10px;
    }

    span {
      max-width: 100px;
    }
  }

  .images {
    width: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    border: none;
    outline: none;
    background-color: transparent;

    img {
      width: 100%;
      margin-bottom: 10px;
    }

    span {
      max-width: 200px;
    }
  }
`

export const NoData = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  img {
    width: 200px;
  }

  span {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.gray80};
    margin-top: 30px;
  }
`

export const CardPrescriptionExams = styled.div`
  width: 100%;
  min-height: 100px;
  margin-bottom: 20px;
  padding: 14px;
  border: 1px solid ${({ theme }) => theme.colors.gray10};
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 150px;
  }

  span {
    color: ${({ theme }) => theme.colors.gray80};
    margin-bottom: 10px;
  }

  @media screen and (min-width: 961px) {
    width: calc(100% / 3 - 10px);
    margin-right: 5px;
    margin-left: 5px;
  }
`

export const AnalysisWrapper = styled.div`
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.gray10};

  &:after {
    content: '';
    width: 42rem;
    height: 15rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: url(${logo});
    background-position: center;
    background-repeat: no-repeat;
    z-index: 0;
    opacity: 0.1;
  }

  .MuiInput-underline {
    padding: 4rem;
    z-index: 2;

    &:after,
    &:before {
      display: none !important;
    }

    &:hover {
      &:after,
      &:before {
        display: none !important;
      }
    }
  }

  .analysisHeader {
    padding: 2rem;

    img {
      max-width: 16rem;
    }
  }

  .analysisFooter {
    background-color: ${({ theme }) => theme.colors.secondary};
    padding: 0.5rem;
    text-align: center;

    a {
      color: #fff;
      font-size: 1.5rem;
    }
  }
`

export const CountCharacters = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.gray80};
`

export const Div = styled.div`
  margin-bottom: 10px;
`

export const TermContent = styled.section`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray10};
  border-radius: ${({ theme }) => theme.radius.default}px;
  padding: 30px;

  span {
    font-size: 18px !important;
    font-weight: 600 !important;
    line-height: 20px !important;
  }

  .subsection {
    .subsection-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;

      p {
        font-size: 16px !important;
        color: ${({ theme }) => theme.colors.dark} !important;
        line-height: 22px !important;
      }
    }
  }
`

export const ContentExam = styled.div`
  width: 100%;
  border: 1px #ccc dashed;
  border-radius: 8px;
  padding: 15px;
  margin-top: 25px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  > img {
    height: 100px;
  }
`

export const ContentPagination = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: flex-end;
  flex-direction: column;
`

export const MessageContainer = styled.div`
  width: 100%;
  min-height: 50px;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.secondaryLight};
  margin-bottom: 15px;
  border-radius: 10px;
  padding: 15px 30px;
`

export const MessageText = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const ContainerMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .foodMenuInput {
    width: 100%;
    height: 44px;
    border-radius: 8px;
    border: 1px solid #d0d5dd;
    padding: 10px 14px;
  }

  .buttonContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 30px;
    padding: 20px 0;
    border-top: 1px solid #e5e7eb;
  }

  .cancelButton {
    padding: 12px 24px;
    background: ${({ theme }) => theme.colors.error};
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
  }

  .saveButton {
    padding: 12px 24px;
    background: ${({ theme }) => theme.colors.primaryDark};
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
  }

  .addOptionButton {
    background: ${({ theme }) => theme.colors.primary};
    color: #f97316;
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    cursor: pointer;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .editHeader {
    background: #f8fafc;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    border: 1px solid #e2e8f0;

    h3 {
      margin: 0 0 10px 0;
      color: #1e293b;
    }

    p {
      margin: 0;
      color: #64748b;
      font-size: 14px;
    }
  }

  .optionsHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    h4 {
      margin: 0;
    }
  }

  .optionItem {
    border: 1px solid #e5e7eb;
    padding: 15px;
    margin-bottom: 10px;
    border-radius: 8px;
    position: relative;
  }

  .removeOptionButton {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .checkboxContainer {
    display: flex;
    align-items: center;
    margin-top: 10px;

    input[type='checkbox'] {
      margin-right: 8px;
    }

    label {
      font-size: 14px;
    }
  }
`

export const ScheduleButtonWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;

  button {
    transition: all 0.3s ease-in-out;
    background: transparent !important;
    border: 1px solid #ffa947 !important;
    color: #ffa947 !important;

    &:not(:disabled):hover {
      background: linear-gradient(135deg, #ff5100 0%, #f99036 100%) !important;
      color: #ffffff !important;
      border-color: transparent !important;
    }
  }

  .custom-tooltip {
    position: absolute;
    bottom: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
    background: #2c2b43;
    color: #ffffff;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 13px;
    line-height: 1.5;
    white-space: normal;
    width: 280px;
    text-align: center;
    opacity: 0;
    visibility: hidden;
    transition:
      opacity 0.3s ease-in-out,
      visibility 0.3s ease-in-out;
    z-index: 1000;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    pointer-events: none;

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 6px solid transparent;
      border-top-color: #2c2b43;
    }
  }

  &.has-credits:hover .custom-tooltip {
    opacity: 1;
    visibility: visible;
  }
`

export const ValidationContainer = styled.div`
  button {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.warning};
    border: 1px solid ${({ theme }) => theme.colors.warning};
    padding: 4px 8px;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
  .checkboxWrapper {
    display: flex;
    gap: 8px;
  }

  .checkboxLabel {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
  }

  .sendButton {
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 600;
    width: 100%;
    height: 44px;
    border-radius: 8px;
    color: #fff;
    background-color: #f97316;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 2px 4px rgba(249, 115, 22, 0.2);
    opacity: 1;

    &:hover:not(:disabled) {
      background-color: #ea580c;
      box-shadow: 0 4px 8px rgba(249, 115, 22, 0.3);
      transform: translateY(-1px);
    }

    &:disabled {
      background-color: #9ca3af;
      cursor: not-allowed;
      opacity: 0.7;
      box-shadow: none;
    }
  }

  .generatePdfButton {
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 600;
    width: 100%;
    height: 44px;
    border-radius: 8px;
    color: #fff;
    background-color: #f97316;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 2px 4px rgba(249, 115, 22, 0.2);
    opacity: 1;

    &:hover:not(:disabled) {
      background-color: #ea580c;
      box-shadow: 0 4px 8px rgba(249, 115, 22, 0.3);
      transform: translateY(-1px);
    }

    &:disabled {
      background-color: #9ca3af;
      cursor: not-allowed;
      opacity: 0.7;
      box-shadow: none;
    }

    .pdfIcon {
      width: 18px;
      height: 18px;
      filter: brightness(0) invert(1);
    }

    .loadingIcon {
      width: 16px;
      height: 16px;
      animation: spin 1s linear infinite;
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

export const NutritionalInfo = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #e2e8f0;

  .nutritionalInfoHeader {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    h3 {
      font-size: 18px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.gray90};
      margin: 0;
    }
  }

  .nutritionalInfoGrid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 16px;
  }

  .nutritionalInfoItem {
    display: flex;
    flex-direction: column;
    padding: 12px;
    background-color: white;
    border-radius: 8px;
    border: 1px solid #e5e7eb;

    .nutritionalInfoLabel {
      font-size: 12px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray60};
      margin-bottom: 4px;
    }

    .nutritionalInfoValue {
      font-size: 18px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.gray90};
    }

    .nutritionalInfoSubValue {
      font-size: 14px;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.gray70};
      margin-top: 4px;
    }
  }

  .macrosGrid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-top: 12px;
  }

  .macroItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px;
    background-color: white;
    border-radius: 8px;
    border: 1px solid #e5e7eb;

    .macroLabel {
      font-size: 12px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray60};
      margin-bottom: 4px;
    }

    .macroValue {
      font-size: 16px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.gray90};
    }
  }
`

export const AdditionalInfo = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  margin-top: 20px;
  border: 1px solid #e2e8f0;

  .additionalInfoHeader {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    h4 {
      font-size: 16px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.gray90};
      margin: 0;
    }
  }

  .additionalInfoItem {
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    .additionalInfoLabel {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray70};
      margin-bottom: 4px;
    }

    .additionalInfoValue {
      font-size: 14px;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.gray90};
      line-height: 1.5;
    }
  }
`

export const SchedulingContainer = styled.div`
  width: 100%;
  padding: 24px;
`

export const SchedulingHeader = styled.div`
  margin-bottom: 24px;
`

export const PendingAppointmentsContainer = styled.div`
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--color-gray-30);
`

export const PendingAppointmentsTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: var(--color-gray-80);
  margin: 0 0 16px 0;
  line-height: 1.5;
`

export const PendingAppointmentsScroll = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: var(--color-gray-10);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color-gray-30);
    border-radius: 3px;

    &:hover {
      background: var(--color-gray-50);
    }
  }
`

export const PendingAppointmentCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid var(--color-gray-30);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`

export const AppointmentInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const AppointmentInfoLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .appointment-icon {
    color: #ff9800;
    font-size: 20px;
    width: 20px;
    height: 20px;
  }

  .appointment-label {
    font-size: 14px;
    color: var(--color-gray-80);
    font-weight: 500;
  }
`

export const AppointmentValue = styled.span`
  font-size: 14px;
  color: var(--color-gray-80);
  font-weight: 500;
  text-align: right;
`

export const SwitchContainer = styled.div`
  margin-bottom: 20px;
  padding-bottom: 20px;

  .switch-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 12px;
  }

  .switch-input {
    position: relative;
    width: 48px;
    height: 24px;
    appearance: none;
    background-color: var(--color-gray-20);
    border-radius: 24px;
    outline: none;
    transition: background-color 0.3s ease;
    cursor: pointer;
    flex-shrink: 0;

    &:checked {
      background-color: var(--color-secondary);
    }

    &::before {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      top: 2px;
      left: 2px;
      background-color: white;
      transition: transform 0.3s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    &:checked::before {
      transform: translateX(24px);
    }
  }

  .switch-text {
    font-size: 16px;
    color: #344054;
    font-weight: 500;
    line-height: 1.5;
    user-select: none;
  }
`

export const InstructionText = styled.p`
  font-size: 16px !important;
  color: #221c35 !important;
  font-weight: 600 !important;
  margin-bottom: 16px !important;
  line-height: 1.5 !important;
`

export const SchedulingContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const CreditsInfo = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: var(--color-gray-80);
  margin-bottom: 16px;

  .credits-value {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: var(--color-secondary) !important;
  }
`

export const NoCreditsMessage = styled.div`
  padding: 24px;
  text-align: center;
  background-color: var(--color-gray-10);
  border-radius: 8px;
  margin-top: 24px;
  color: var(--color-gray-60);
  font-size: 14px;
`

export const FormGroup = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: var(--color-gray-80);
    font-size: 14px;
  }
`

export const CalendarSection = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    margin-bottom: 12px;
    font-weight: 500;
    color: var(--color-gray-80);
    font-size: 14px;
  }

  .calendar {
    background: white;
    border-radius: 8px;

    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      margin-bottom: 8px;

      .calendar-nav {
        background: none;
        border: none;
        font-size: 16px;
        cursor: pointer;
        padding: 8px;
        color: var(--color-gray-50);
        transition: color 0.2s ease;

        &:hover {
          color: var(--color-gray-80);
        }
      }

      .calendar-month {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
        color: var(--color-gray-80);
      }
    }

    &-grid {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      gap: 4px;
      padding: 8px;
    }

    &-day-header {
      padding: 8px 4px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      color: var(--color-gray-50);
      margin-bottom: 4px;
    }

    &-day {
      background: white;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.2s ease;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin: 0 auto;
      position: relative;

      &:hover:not(.empty):not(.selected) {
        background-color: var(--color-gray-10);
      }

      &.empty {
        background: transparent;
        cursor: default;
        visibility: hidden;
      }

      &.selected {
        background-color: var(--color-secondary-light);
        color: var(--color-secondary) !important;
        font-weight: 500;
      }

      &.highlighted {
        border: 1px solid var(--color-secondary);
        background-color: transparent;
        color: var(--color-secondary);
        font-weight: 500;
      }

      &.available {
        background-color: var(--color-secondary-light);
        color: var(--color-secondary);
        font-weight: 500;
        cursor: pointer;
      }

      &.clickable {
        opacity: 1;
        cursor: pointer;
        color: var(--color-gray-80);

        &.selected {
          color: var(--color-secondary) !important;
        }
      }

      &:not(.available):not(.empty):not(.highlighted):not(.clickable) {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }
  }
`

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const TimeSelection = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    margin-bottom: 12px;
    font-weight: 500;
    color: var(--color-gray-80);
    font-size: 14px;
  }

  .time-slots {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .loading-times {
    text-align: center;
    padding: 20px;
    color: var(--color-gray-50);
    font-style: italic;
  }

  .no-times {
    text-align: center;
    padding: 20px;
    color: var(--color-gray-50);
    font-style: italic;
    background: var(--color-gray-10);
    border-radius: 8px;
    border: 1px dashed var(--color-gray-30);
  }

  .time-slot {
    background: var(--color-gray-10);
    border: 1px solid var(--color-gray-30);
    border-radius: 16px;
    padding: 12px 16px;
    cursor: pointer;
    font-size: 14px;
    color: var(--color-gray-80);
    transition: all 0.2s ease;
    min-width: 80px;
    height: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: var(--color-secondary-light);
      border-color: var(--color-secondary);
      color: var(--color-secondary);
    }

    &.selected {
      background: var(--color-secondary-light);
      border: 1px solid var(--color-secondary);
      color: var(--color-secondary);
      font-weight: 500;
    }
  }
`

export const GuaranteeSection = styled.div`
  background-color: #fff5ec;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;

  .guarantee-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin-bottom: 12px;

    input[type='checkbox'] {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }

    span {
      font-size: 14px;
      font-weight: 500;
      color: var(--color-gray-80);
    }
  }

  .guarantee-description {
    font-size: 12px;
    color: var(--color-gray-60);
    margin: 0 0 12px 0;
    line-height: 1.5;
  }

  .guarantee-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;
    color: #000000;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }

    .link-text {
      color: #000000;
    }
  }
`

export const FAQIcon = styled.span<{ isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  transform: ${({ isExpanded }) =>
    isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  margin-left: 16px;

  img {
    width: 16px;
    height: 16px;
    filter: grayscale(100%) brightness(0.6);
  }
`

export const HowItWorksContent = styled.div`
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
`

export const HowItWorksItem = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const HowItWorksQuestion = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #221c35;
  margin: 0 0 8px 0;
`

export const HowItWorksAnswer = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: var(--color-gray-70);
  margin: 0;
  line-height: 1.5;
`

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  padding-top: 20px;
`

export const AppointmentsSelectionContainer = styled.div`
  width: 100%;
  padding: 24px;
`

export const AppointmentsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`

export const AppointmentsTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #221c35;
  margin: 0;
`

export const DurationInfo = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: var(--color-gray-80);
  font-weight: 500;
`

export const CurrentMonthText = styled.div`
  width: 100%;
  background-color: var(--color-gray-10);
  border: 1px solid var(--color-gray-30);
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--color-gray-80);
  margin-bottom: 24px;
  text-align: center;
`

export const AppointmentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const FutureCreditsBanner = styled.div`
  grid-column: 1 / -1;
  background: linear-gradient(135deg, #ff5100 20%, #f99036 80%);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;

  .banner-icon {
    width: 18px;
    height: 18px;
    filter: brightness(0) invert(1);
  }

  .banner-text {
    font-size: 14px;
    font-weight: 500;
    color: white;
  }
`

export const AppointmentCard = styled.div`
  background-color: var(--color-gray-10);
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 16px;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--color-gray-30);
    background-color: white;
  }

  &.selected {
    border-color: #ffa947;
    background-color: white;
  }

  .card-checkbox {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 1;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 2px solid var(--color-gray-30);
    border-radius: 6px;
    background-color: white;
    transition: all 0.2s ease;
    margin: 0;
    padding: 0;

    &:checked {
      background-color: white;
      border-color: #ffa947;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -60%) rotate(45deg);
        width: 4px;
        height: 8px;
        border: solid #ffb366;
        border-width: 0 1.5px 1.5px 0;
        border-radius: 0;
      }
    }
  }

  &.selected {
    border-color: #ffa947;
  }
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`

export const CardSelectText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--color-gray-80);
`

export const CardInfoRow = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: var(--color-gray-70);

  .info-label {
    font-weight: 500;
    margin-right: 4px;
  }

  .info-value {
    font-weight: 400;
    color: var(--color-gray-80);
  }
`

export const CardEditButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  border: none;
  color: #ffa947;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  margin-top: 16px;

  &:hover:not(:disabled) {
    background-color: rgba(255, 169, 71, 0.1);
    color: #ffa947;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    color: var(--color-gray-50);
  }
`

export const ConfirmButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
  border-top: 1px solid var(--color-gray-20);
`

export const EditModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`

export const EditModalContent = styled.div`
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`

export const EditModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--color-gray-20);

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #221c35;
  }

  button {
    background: none;
    border: none;
    font-size: 24px;
    color: var(--color-gray-60);
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover {
      background-color: var(--color-gray-10);
      color: var(--color-gray-80);
    }
  }
`

export const EditModalBody = styled.div`
  padding: 24px;
`

export const EditCalendarSection = styled.div`
  margin-bottom: 24px;

  label {
    display: block;
    margin-bottom: 12px;
    font-weight: 500;
    color: var(--color-gray-80);
    font-size: 14px;
  }

  .calendar {
    background: white;
    border-radius: 8px;

    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      margin-bottom: 8px;

      .calendar-nav {
        background: none;
        border: none;
        font-size: 16px;
        cursor: pointer;
        padding: 8px;
        color: var(--color-gray-50);
        transition: color 0.2s ease;

        &:hover {
          color: var(--color-gray-80);
        }
      }

      .calendar-month {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
        color: var(--color-gray-80);
      }
    }

    &-grid {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      gap: 4px;
      padding: 8px;
    }

    &-day-header {
      padding: 8px 4px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      color: var(--color-gray-50);
      margin-bottom: 4px;
    }

    &-day {
      background: white;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.2s ease;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin: 0 auto;
      position: relative;

      &:hover:not(.empty):not(.selected) {
        background-color: var(--color-gray-10);
      }

      &.empty {
        background: transparent;
        cursor: default;
        visibility: hidden;
      }

      &.selected {
        background-color: var(--color-secondary-light);
        color: var(--color-secondary) !important;
        font-weight: 500;
      }

      &.highlighted {
        border: 1px solid var(--color-secondary);
        background-color: transparent;
        color: var(--color-secondary);
        font-weight: 500;
      }

      &.available {
        background-color: var(--color-secondary-light);
        color: var(--color-secondary);
        font-weight: 500;
        cursor: pointer;
      }

      &:not(.available):not(.empty):not(.selected) {
        opacity: 0.4;
        cursor: not-allowed;
      }

      &:not(.available):not(.empty):not(.highlighted):not(.clickable) {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }
  }
`

export const EditTimeSelection = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    margin-bottom: 12px;
    font-weight: 500;
    color: var(--color-gray-80);
    font-size: 14px;
  }

  .time-slots {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .loading-times {
    text-align: center;
    padding: 20px;
    color: var(--color-gray-50);
    font-style: italic;
  }

  .no-times {
    text-align: center;
    padding: 20px;
    color: var(--color-gray-50);
    font-style: italic;
    background: var(--color-gray-10);
    border-radius: 8px;
    border: 1px dashed var(--color-gray-30);
  }

  .time-slot {
    background: var(--color-gray-10);
    border: 1px solid var(--color-gray-30);
    border-radius: 16px;
    padding: 12px 16px;
    cursor: pointer;
    font-size: 14px;
    color: var(--color-gray-80);
    transition: all 0.2s ease;
    min-width: 80px;
    height: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: var(--color-secondary-light);
      border-color: var(--color-secondary);
      color: var(--color-secondary);
    }

    &.selected {
      background: var(--color-secondary-light);
      border: 1px solid var(--color-secondary);
      color: var(--color-secondary);
      font-weight: 500;
    }
  }
`

export const EditInlineContainer = styled.div`
  background: white;
  border: 2px solid var(--color-gray-20);
  border-radius: 12px;
  padding: 20px;
  margin-top: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

export const EditInlineFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid var(--color-gray-20);
`

export const EditModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid var(--color-gray-20);
`

export const ReminderContainer = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #f48c42;
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  position: relative;

  .reminder-icon {
    width: 40px;
    height: 40px;
    min-width: 40px;
    background: #fef3e5;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 22px;
      height: 22px;
    }
  }

  .reminder-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .reminder-title {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    color: #101828;
    margin: 0;
  }

  .reminder-text {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #344054;
    margin: 0;
  }

  .reminder-close {
    position: absolute;
    top: 12px;
    right: 16px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: #667085;
    font-size: 62px;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease;

    &:hover {
      color: #344054;
    }
  }

  .reminder-copy-btn {
    background: transparent;
    border: 1px solid #f48c42;
    border-radius: 8px;
    padding: 8px 16px;
    color: #f48c42;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    width: fit-content;

    &:hover {
      background: #f48c42;
      color: #fff;
    }
  }
`
